// Admin User Form - Handle Auth0 account creation and email verification interactions
document.addEventListener('DOMContentLoaded', function() {
  const createAuth0Checkbox = document.getElementById('create_auth0_account');
  const auth0Options = document.getElementById('auth0_options');
  const setPasswordRadio = document.getElementById('auth0_set_password');
  const sendResetRadio = document.getElementById('auth0_send_reset');
  const passwordField = document.getElementById('password_field');
  const sendVerificationCheckbox = document.getElementById('send_verification_email');

  // Exit early if we're not on the admin user form
  if (!createAuth0Checkbox || !auth0Options) return;

  // Show/hide Auth0 options based on checkbox
  function toggleAuth0Options() {
    if (createAuth0Checkbox.checked && !createAuth0Checkbox.disabled) {
      auth0Options.style.display = 'block';
      togglePasswordField();
    } else {
      auth0Options.style.display = 'none';
    }
  }

  // Show/hide password field based on radio selection
  function togglePasswordField() {
    if (setPasswordRadio.checked) {
      passwordField.style.display = 'block';
    } else {
      passwordField.style.display = 'none';
    }
  }

  // Disable Auth0 creation if email verification is checked
  function toggleAuth0Availability() {
    if (sendVerificationCheckbox.checked) {
      createAuth0Checkbox.checked = false;
      createAuth0Checkbox.disabled = true;
      // Remove name attribute so it doesn't submit when disabled
      createAuth0Checkbox.removeAttribute('name');
      auth0Options.style.display = 'none';
      
      // Add visual indication that it's disabled
      const auth0Card = document.querySelector('#create_auth0_account').closest('.card');
      auth0Card.style.opacity = '0.6';
      
      // Show explanatory message
      let disabledMsg = document.getElementById('auth0_disabled_message');
      if (!disabledMsg) {
        disabledMsg = document.createElement('p');
        disabledMsg.id = 'auth0_disabled_message';
        disabledMsg.className = 'text-muted small mt-2 mb-0';
        disabledMsg.innerHTML = '<em>Auth0 account creation is disabled when sending email verification. User will set up their own account through the verification flow.</em>';
        document.querySelector('#create_auth0_account').closest('.form-check').appendChild(disabledMsg);
      }
    } else {
      createAuth0Checkbox.disabled = false;
      // Restore name attribute so it can submit when enabled
      createAuth0Checkbox.setAttribute('name', 'integrations[]');
      
      // Remove visual indication
      const auth0Card = document.querySelector('#create_auth0_account').closest('.card');
      auth0Card.style.opacity = '1';
      
      // Remove explanatory message
      const disabledMsg = document.getElementById('auth0_disabled_message');
      if (disabledMsg) {
        disabledMsg.remove();
      }
    }
    toggleAuth0Options();
  }

  // Add event listeners
  createAuth0Checkbox.addEventListener('change', toggleAuth0Options);
  setPasswordRadio.addEventListener('change', togglePasswordField);
  sendResetRadio.addEventListener('change', togglePasswordField);
  sendVerificationCheckbox.addEventListener('change', toggleAuth0Availability);

  // Initialize on page load
  toggleAuth0Availability();
  toggleAuth0Options();
});

